import * as React from "react";
import PropTypes from "prop-types";

import "./content.css";
import { formatPrice, _ } from "../../model/utils";
import Icon from "./icon";

const ExperienceContent = ({ experience }) => (
  <>
    <div styleName="abstract">{experience.description}</div>
    <div styleName="icons">
      <Icon value={experience.duration} iconName="clock-o" />
      <Icon value={experience.glasses} iconName="glass" />
      <Icon value={formatPrice(experience.price)} iconName="eur" />
    </div>
    {experience.wines && experience.wines.length > 0 && (
      <div styleName="wines">
        <div styleName="wines-subtitle">{_.chosenWines}</div>
        <div className="row">
          {experience.wines.map((wine, i) => (
            <div className="col-md-6" key={i}>
              <div styleName="wine">{wine}</div>
            </div>
          ))}
        </div>
      </div>
    )}
  </>
);

ExperienceContent.propTypes = {
  experience: PropTypes.shape({
    description: PropTypes.string,
    duration: PropTypes.string,
    glasses: PropTypes.string,
    price: PropTypes.number,
    wines: PropTypes.arrayOf(PropTypes.string)
  })
};

export default ExperienceContent;
